


























import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ElTree } from "element-ui/types/tree";
import { FormatSetTreeEditModel } from ".";
import {
  FormatSet,
  IFormatSetTreeNode,
  IFormatSetTreeData,
  FormatReference
} from "../../../../../domain/format";
import { Directory, RootDirectory } from "../../../../../domain/drawing";
import { ModelEditableMixin } from "../../../../system/mixins";
import { DirectoryTreeNodesFactory } from "../../../../system/utilities/DirectoryTreeNodesFactory";
import { FormatTreeNodeUtility } from "../../../../format/selectors/trees/utilities";
import { TreeNodeDropType } from "../../../../../domain/system";

@Component({
})
export default class FormatSetTreeEditor extends Mixins(ModelEditableMixin) {
  private static readonly _nodeUtility = new FormatTreeNodeUtility();

  mounted(): void {
    this.loadNodes();
  }

  data(): any {
    return {
      factory: null as DirectoryTreeNodesFactory<string, FormatSet>,
      nodes: null as IFormatSetTreeData[],
      selectedNode: null as IFormatSetTreeNode,
    };
  }
  factory: DirectoryTreeNodesFactory<string, FormatSet>;
  nodes: IFormatSetTreeData[];
  selectedNode: IFormatSetTreeNode;

  @Prop()
  shouldAddRootFolder: boolean;
  
  get editDialogModel(): FormatSetTreeEditModel {
    return this.editingSource;
  }

  get editingDirectory(): RootDirectory<string, FormatSet> {
    return this.editDialogModel.editingDirectory;
  }

  get selectedDirectory(): Directory<string, FormatSet> {
    return this.editDialogModel.selectedDirectory;
  }

  set selectedDirectory(value: Directory<string, FormatSet>) {
    this.editDialogModel.selectedDirectory = value;
  }

  get selectedFormatSet(): FormatSet {
    return this.editDialogModel.selectedFormatSet;
  }

  set selectedFormatSet(value: FormatSet) {
    this.editDialogModel.selectedFormatSet = value;
  }

  get selectedFormat(): FormatReference {
    return this.editDialogModel.selectedFormat;
  }

  set selectedFormat(value: FormatReference) {
    this.editDialogModel.selectedFormat = value;
  }

  get editFolderText(): string {
    return this.editDialogModel.editFolderText;
  }

  get editFormatSetText(): string {
    return this.editDialogModel.editFormatSetText;
  }

  get editFormatText(): string {
    return this.editDialogModel.editFormatText;
  }

  get addFolderText(): string {
    return this.editDialogModel.addFolderText;
  }

  get addFormatSetText(): string {
    return this.editDialogModel.addFormatSetText;
  }

  get addDirectory(): Directory<string, FormatSet> {
    return this.editDialogModel.addDirectory;
  }

  get addFormats(): FormatReference[] {
    return this.editDialogModel.addFormats;
  }

  get deleteFolderFlag(): boolean {
    return this.editDialogModel.deleteFolderFlag;
  }

  get deleteFormatSetFlag(): boolean {
    return this.editDialogModel.deleteFormatSetFlag;
  }

  get deleteFormatFlag(): boolean {
    return this.editDialogModel.deleteFormatFlag;
  }

  get updateCompletedDirectoryFlag(): boolean {
    return this.editDialogModel.updateCompletedDirectoryFlag;
  }

  get completedDirectory(): RootDirectory<string, FormatSet> {
    return this.editDialogModel.completedDirectory;
  }

  set completedDirectory(value: RootDirectory<string, FormatSet>) {
    this.editDialogModel.completedDirectory = value;
  }

  @Watch("editingDirectory")
  onEditingDirectoriesChanged(newValue: Directory<string, FormatReference>[], oldValue: Directory<string, FormatReference>[]): void {
    this.loadNodes();
  }

  @Watch("editFolderText")
  onEditFolderTextChanged(newValue: string, oldValue: string): void {
    if (!newValue || newValue.length === 0) {
      return;
    }
    this.setNodeLabel(newValue);
  }

  @Watch("editFormatSetText")
  onEditFormatSetTextChanged(newValue: string, oldValue: string): void {
    if (!newValue || newValue.length === 0) {
      return;
    }
    this.setNodeLabel(newValue);
  }

  @Watch("addFolderText")
  onAddFolderTextChanged(newValue: string, oldValue: string): void {
    if (!newValue || newValue === "") {
      return;
    }
    this.addFolder(newValue);
  }

  @Watch("addFormatSetText")
  onAddFormatSetTextChanged(newValue: string, oldValue: string): void {
    if (!newValue || newValue === "") {
      return;
    }
    this.addFormatSetPhrase(newValue);
  }

  @Watch("addFormats")
  onAddFormatsChanged(newValue: FormatReference[], oldValue: FormatReference[]): void {
    if (!newValue || newValue.length === 0) {
      return;
    }
    this.addFormatReferences(newValue);
  }

  @Watch("deleteFolderFlag")
  onDeleteFolderFlagChanged(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      return;
    }
    this.deleteNode();
  }

  @Watch("deleteFormatSetFlag")
  onDeleteFormatSetFlagChanged(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      return;
    }
    this.deleteNode();
  }

  @Watch("deleteFormatFlag")
  onDeleteFormatFlagChanged(newValue: boolean, oldValue: boolean): void {
    if (!newValue || !this.selectedFormatSet || !this.selectedFormat) {
      return;
    }
    this.selectedFormatSet.formats = this.selectedFormatSet.formats.filter(f => f !== this.selectedFormat);
  }

  @Watch("updateCompletedDirectoryFlag")
  onUpdateCompletedDirectoryFlagChanged(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      return;
    }
    const tree = this.getTreeComponent();
    this.completedDirectory = FormatSetTreeEditor._nodeUtility.toFormatSetRootDirectory(tree.data);
  }

  private loadNodes(): void {
    // thisをバインドしておかないと実行時のthisが変わるのでアロー関数でバインド.
    this.factory = new DirectoryTreeNodesFactory(
      (e: FormatSet, i: number) => FormatSetTreeEditor._nodeUtility.toFormatSetNode(e, i));
    // nodesを算出プロパティで処理するとツリーの変更が行われるたびに呼び出され、ツリーの開閉状態が初期化されてしまうため分離した
    this.nodes = this.factory.createFromRootDirectory(this.editingDirectory);
    this.selectedNode = null;
  }

  private getTreeComponent(): ElTree<string, IFormatSetTreeData> {
    return this.$refs.tree as ElTree<string, IFormatSetTreeData>;
  }

  nodeClass(node: IFormatSetTreeNode): string {
    return FormatSetTreeEditor._nodeUtility.nodeIconClass(node);
  }

  nodeLabel(node: IFormatSetTreeNode): string {
    return node.label;
  }

  shouldShowNodeKey(data: IFormatSetTreeData): boolean {
    return data.source instanceof Directory && !!data.source.key && this.$configuration.behavior.setting.shouldShowTreeNodeKey;
  }

  nodeKey(data: IFormatSetTreeData): string {
    return this.shouldShowNodeKey(data) && data.source instanceof Directory
      ? " (" + data.source.key + ")"
      : "";
  }

  shouldShowNodeId(data: IFormatSetTreeData): boolean {
    // 文書セットは頻用フォーマットと違ってキーが格納されているので、キー表示有無の設定に従う挙動としている
    return data.source instanceof FormatSet && !!data.source.id && this.$configuration.behavior.setting.shouldShowTreeNodeKey;
  }

  nodeId(data: IFormatSetTreeData): string {
    return this.shouldShowNodeId(data) && data.source instanceof FormatSet
      ? " (" + data.source.id + ")"
      : "";
  }

  handleNodeClicked(nodeObject: IFormatSetTreeData, nodeProperty: IFormatSetTreeNode, nodeSelf: any): void {
    const source = nodeObject.source;
    if (source instanceof Directory) {
      this.selectedDirectory = source;
      this.selectedFormatSet = null;
      this.selectedFormat = null;
    }
    if (source instanceof FormatSet) {
      this.selectedDirectory = null;
      this.selectedFormatSet = source;
      this.selectedFormat = null;
    }
    if (nodeProperty.childNodes instanceof Array && nodeProperty.childNodes.length === 0) {
      nodeProperty.expanded = false;  // 移動等でファイルが無くなっていた場合はとりあえず閉じる
    }
    this.selectedNode = nodeProperty;
  }

  private setNodeLabel(lable: string): void {
    if (this.selectedNode === null) {
      return;
    }
    const data = this.selectedNode.data;
    if (data.source instanceof Directory) {
      const source = data.source as Directory<string, FormatSet>;
      source.name = lable;
      data.label = lable;
    } else if (data.source instanceof FormatSet) {
      const source = data.source as FormatSet;
      source.name = lable;
      data.label = lable;
    }
  }

  private addFolder(label: string): void {
    // 共通のpublishIdを使用するためfactory経由でデータを作成
    const dir = [
      new Directory<string, FormatSet>(null, label, [], []
    )];
    const nodes = this.factory.create(dir);
    this.addNode(nodes[0]);
  }

  private addFormatSetPhrase(label: string): void {
    // 共通のpublishIdを使用するためfactory経由でデータを作成
    const formatSet = new FormatSet(null, label, [], null);
    const dir = [
      new Directory<string, FormatSet>(null, "tmp", [], [formatSet])
    ];
    const nodes = this.factory.create(dir);
    Enumerable.from(nodes[0].children)
      .forEach(c => this.addNode(c));
  }

  private addFormatReferences(formats: FormatReference[]): void {
    if (!this.selectedFormatSet) { return; }
    this.selectedFormatSet.formats = this.selectedFormatSet.formats.concat(formats);
  }

  private addNode(childData: IFormatSetTreeData): void {
    const tree = this.getTreeComponent();
    if (this.selectedNode === null || this.shouldAddRootFolder) {
      const node = tree as any; // rootが必要なのでanyに変換
      tree.append(childData, node.root);
    } else {
      tree.append(childData, this.selectedNode.data);
      this.sortNode(this.selectedNode);
      this.selectedNode.expanded = true;  // 追加したので開く
    }
  }

  private deleteNode(): void {
    if (this.selectedNode === null) {
      return;
    }
    const tree = this.getTreeComponent();
    tree.remove(this.selectedNode.data);
    this.selectedNode = null;
    this.selectedDirectory = null;
    this.selectedFormatSet = null;
    this.selectedFormat = null;
  }

  allowDrop(draggingNode: IFormatSetTreeNode, dropNode: IFormatSetTreeNode, type: TreeNodeDropType): boolean {
    const dropNodeSource = dropNode.data.source;
    if (dropNodeSource instanceof FormatSet && type === "inner") {
      return false; // セットの内側は全て禁止
    }
    const draggingNodeSource = draggingNode.data.source;
    if (draggingNodeSource instanceof FormatSet
      && dropNodeSource instanceof Directory
      && type !== "inner") {
      // D&Dの処理をフォーマットツリー編集機能から移植しているが、この分岐の意味するところが不明
      // あっても悪影響は無さそうなのでそのまま持ってきている
      return false;
    }
    // フォーマットツリー編集機能のほうはキーが登録されているフォルダはルート以外禁止されているが、
    // セットはすべての階層でキーを付与するため許可している
    return true;
  }

  allowDrag(draggingNode: IFormatSetTreeNode): boolean {
    return true;
  }

  nodeDrop(draggingNode: IFormatSetTreeNode, dropNode: IFormatSetTreeNode, type: TreeNodeDropType): void {
    this.sortNode(type === "inner"
      ? dropNode          // ドロップ先をソート
      : dropNode.parent); // ドロップした兄弟をソートするため親を渡す
    dropNode.expanded = true; // 追加したので開く
  }

  private sortNode(node: IFormatSetTreeNode): void {
    if (node.childNodes instanceof Array) {
      node.childNodes.sort((a: IFormatSetTreeNode, b: IFormatSetTreeNode) => {
        const sourceA = a.data.source instanceof Directory ? 0 : 1;
        const sourceB = b.data.source instanceof Directory ? 0 : 1;
        return sourceA - sourceB;
      });
    }
    if (node.data !== null && node.data.children instanceof Array) {
      node.data.children.sort((a: IFormatSetTreeData, b: IFormatSetTreeData) => {
        const sourceA = a.source instanceof Directory ? 0 : 1;
        const sourceB = b.source instanceof Directory ? 0 : 1;
        return sourceA - sourceB;
      });
    }
  }
}
